<div class="grid grid-i3">
	<tec-info-group [label]="'PROCESSES.DETAIL.ID_OPERATION' | translate">
		<tec-copy-text
			[label]="displayTruncatedUuid(operationUuid)"
			[labelToCopy]="operationUuid ?? ''"
		/>
	</tec-info-group>

	@if (showProcessLink) {
		<tec-info-group [label]="'OPERATIONS.DETAIL.ID_PROCESS' | translate">
			@if (rolePermissions.canViewProcesses()) {
				<tec-link
					[href]="'/processes/detail/' + processUuid"
					[label]="displayTruncatedUuid(processUuid)"
				/>
			} @else {
				<span>{{ displayTruncatedUuid(processUuid) }}</span>
			}
		</tec-info-group>
	}

	@if (triesStyle) {
		<tec-info-group [label]="'PROCESSES.DETAIL.NUM_TRIED' | translate">
			@if (triesStyle === 'badge') {
				<tec-badge [label]="resolvedTriesLabel()" type="square" />
			} @else {
				<tec-tag [label]="resolvedTriesLabel()" />
			}
			@if (showKoIcon) {
				<tec-tag-icon
					class="form-operation-detail-tag-icon"
					size="sm"
					[icon]="'icon-alert'"
				/>
			}
		</tec-info-group>
	}

	@if (captureMethodLabel) {
		<tec-info-group [label]="'PROCESSES.DETAIL.CAPTURE_METHOD' | translate">
			<tec-tag [label]="captureMethodLabel" />
			@if (showMiDni) {
				<img
					src="images/midni-logo.png"
					alt="App MiDNI"
					style="height: 20px; vertical-align: middle; margin-left: 4px"
					title="Verificado con la app MiDNI"
				/>
			}
		</tec-info-group>
	}

	@if (typeLabel) {
		<tec-info-group [label]="'PROCESSES.DETAIL.TYPE' | translate">
			<span>{{ typeLabel }}</span>
		</tec-info-group>
	}

	@if (obtainMethodLabel) {
		<tec-info-group [label]="'PROCESSES.DETAIL.OBTAIN_METHOD' | translate">
			<tec-tag [label]="obtainMethodLabel" />
		</tec-info-group>
	}

	@if (verificationLabel) {
		<tec-info-group [label]="'PROCESSES.DETAIL.VERIFICATION' | translate">
			<tec-tag [label]="verificationLabel" />
		</tec-info-group>
	}
</div>

<tec-divider />

<div class="grid grid-i3">
	<tec-info-group [label]="'PROCESSES.DETAIL.START_DATE' | translate">
		<tec-icon name="icon-calendar" size="xs" />
		<span>{{ formatStartDate() }}</span>
	</tec-info-group>
	<tec-info-group [label]="'PROCESSES.DETAIL.END_DATE' | translate">
		<tec-icon name="icon-calendar" size="xs" />
		<span>{{ formatEndDate() }}</span>
	</tec-info-group>
	<tec-info-group [label]="'PROCESSES.DETAIL.DURATION' | translate">
		<tec-icon name="icon-clock" size="xs" />
		<span>{{ formatOperationDuration() }}</span>
	</tec-info-group>
</div>
